export default function Footer() {
    return null;
}
